import { Controller } from "@hotwired/stimulus"

// Charge dynamiquement le banner d'alertes client quand un client est sélectionné
// Usage: data-controller="client-alert-loader"
//        data-client-alert-loader-url-template-value="/clients/:client_id/client_alerts/active_for_client"
//        data-client-alert-loader-input-id-value="client-combobox-hidden-input"

export default class extends Controller {
  static values = {
    urlTemplate: String,
    inputId: String
  }

  connect() {
    // Trouver le champ caché du combobox et écouter ses changements
    this.inputElement = document.getElementById(this.inputIdValue)
    
    if (this.inputElement) {
      this._handleChange = this.loadAlerts.bind(this)
      this.inputElement.addEventListener("change", this._handleChange)
      
      // Si un client est déjà sélectionné, charger les alertes
      if (this.inputElement.value) {
        this.loadAlerts()
      }
    }
  }

  disconnect() {
    if (this.inputElement && this._handleChange) {
      this.inputElement.removeEventListener("change", this._handleChange)
    }
  }

  loadAlerts() {
    const clientId = this.inputElement?.value

    // Si pas de client sélectionné, vider le conteneur
    if (!clientId) {
      this.element.innerHTML = ""
      return
    }

    // Construire l'URL avec le client_id
    const url = this.urlTemplateValue.replace(":client_id", clientId)

    // Charger le banner via fetch
    fetch(url, {
      headers: {
        "Accept": "text/html",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
      .then(response => {
        if (response.ok) {
          return response.text()
        }
        throw new Error("Erreur lors du chargement des alertes")
      })
      .then(html => {
        this.element.innerHTML = html
      })
      .catch(error => {
        console.error("Erreur:", error)
        this.element.innerHTML = ""
      })
  }
}
